import {fetchHelper} from '../helpers/request_helper';
import {
    NOTIFICATION_INBOX_URL,
    NOTIFICATION_UNREAD_COUNT_URL,
    NOTIFICATION_MARK_SEEN_URL,
    NOTIFICATION_PREFERENCES_URL
} from '../constants/api_paths';

export const notificationsService = {
    getUnreadCount,
    getInbox,
    markSeen,
    getPreferences,
    updatePreferences
};

/**
 * Fetch unread notification count for the current user
 *
 * @returns {object} promise object
 */
function getUnreadCount() {
    return fetchHelper.callGet(NOTIFICATION_UNREAD_COUNT_URL);
}

/**
 * Fetch notification inbox page
 *
 * @param {object} params - { offset, limit }
 * @returns {object} promise object
 */
function getInbox(params) {
    return fetchHelper.callGet(NOTIFICATION_INBOX_URL, params);
}

/**
 * Mark a notification campaign as seen
 *
 * @param {string} campaignId - the campaign id to mark as seen
 * @returns {object} promise object
 */
function markSeen(campaignId) {
    return fetchHelper.callPost(NOTIFICATION_MARK_SEEN_URL.replace('{campaignId}', campaignId));
}

/**
 * Fetch notification preferences for the current user
 *
 * @returns {object} promise object resolving to { announcementsOptedOut: boolean }
 */
function getPreferences() {
    return fetchHelper.callGet(NOTIFICATION_PREFERENCES_URL);
}

/**
 * Update notification preferences for the current user
 *
 * @param {object} body - { announcementsOptedOut: boolean }
 * @returns {object} promise object resolving to the updated preferences
 */
function updatePreferences(body) {
    return fetchHelper.callPut(NOTIFICATION_PREFERENCES_URL, body);
}
